import React from 'react';
import styles from './DateHeader.module.scss';
const DateHeader = () => {
  return (
    <div className={styles.dateHeader}>
      {
        [
          '日',
          '一',
          '二',
          '三',
          '四',
          '五',
          '六'
        ].map((el, key) => {
          return (
            <div className={styles.dateHeaderCeil} key ={key}>
              {el}
            </div>
          );
        })
      }
    </div>
  );
};

export default DateHeader;
